var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _BioExamPrescribedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import Patient from "core/models/patient";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import PrescriptionJournalEvent from "./prescription-journal-event";

//---- Automatically generated, don't update this part ----
let BioExamPrescribedJournalEvent = (_dec = attr({
  defaultValue() {
    return [];
  }
}), _dec2 = attr("string", {
  defaultValue() {
    return "none";
  }
}), _dec3 = attr("string"), _dec4 = attr("number"), _dec5 = attr("string"), _dec6 = attr("boolean", {
  allowNull: true
}), _dec7 = belongsTo("patient", {
  async: false,
  inverse: "bioExamPrescribedJournalEvents"
}), _dec8 = attr("string"), _class = (_BioExamPrescribedJournalEvent = class BioExamPrescribedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    /**
     * The list of bio exam orders
     */
    _initializerDefineProperty(this, "exams", _descriptor, this);
    /**
     * The frequency of the current prescription
     * alert-type:
     */
    _initializerDefineProperty(this, "frequency", _descriptor2, this);
    /**
     * Some custom orders to add in the prescription
     */
    _initializerDefineProperty(this, "customOrders", _descriptor3, this);
    /**
     * Validity period of the prescription, in month
     */
    _initializerDefineProperty(this, "validityPeriod", _descriptor4, this);
    _initializerDefineProperty(this, "aldRelatedComments", _descriptor5, this);
    /**
     * The rules should create an alert or not when the prescription expires soon
     */
    _initializerDefineProperty(this, "createExpirationAlert", _descriptor6, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor7, this);
    /**
     * @type {string}
     */
    _initializerDefineProperty(this, "uuid", _descriptor8, this);
  }
  static validations(intl) {
    return {
      frequency: [validatePresence({
        presence: true,
        description: intl.t("validations.bio-exam-prescribed-journal-event.frequency")
      }), validateInclusion({
        list: ["none", "1-day", "1-week", "2-week", "1-month", "2-month", "3-month", "4-month", "5-month", "6-month", "1-year"],
        description: intl.t("validations.bio-exam-prescribed-journal-event.frequency")
      })],
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.bio-exam-prescribed-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })],
      validityPeriod: validateNumber({
        allowBlank: true,
        integer: true,
        description: intl.t("validations.bio-exam-prescribed-journal-event.validity-period")
      })
    };
  }
  get startDate() {
    return this.occurredAt;
  }
  get endDate() {
    if (!this.validityPeriod) {
      return;
    }
    const endDate = new Date(this.occurredAt);
    endDate.setMonth(endDate.getMonth() + this.validityPeriod);
    return endDate;
  }
  async renew() {
    const prescriptionRenewed = await this.store.createRecord("bio-exam-prescribed-journal-event", {
      occurredAt: new Date(),
      patient: this.patient,
      validityPeriod: this.validityPeriod,
      exams: this.exams,
      frequency: this.frequency,
      customOrders: this.customOrders,
      aldRelatedComments: this.aldRelatedComments,
      comments: this.comments
    }).save();
    return prescriptionRenewed;
  }
  get pdfUrl() {
    return `/api/v1/bio_exam_prescriptions/${this.id}`;
  }
}, _defineProperty(_BioExamPrescribedJournalEvent, "type", "bio-exam-prescribed-journal-event"), _BioExamPrescribedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "exams", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "frequency", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "customOrders", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "validityPeriod", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "aldRelatedComments", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "createExpirationAlert", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "uuid", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BioExamPrescribedJournalEvent as default };